import { OperationalMode, operationalMode } from "../constants/mode";

export const isKioskMode = () => operationalMode === OperationalMode.Kiosk;
